export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.global.ok': 'OK',
  'component.global.cancel': 'Cancel',
  'component.global.search': 'Search',
};
